import { Drawer } from 'antd';
import moment from 'moment';
import ScheduleCreateUpdateComponent from '../../components/schedules/ScheduleCreateUpdateComponent';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../modules';
import {
  ScheduleListType,
  getScheduleListAsync,
  updateScheduleAsync,
} from '../../modules/schedules';
import Title from 'antd/lib/typography/Title';

interface ScheduleEditDrawerProps {
  enterpriseId: string;
  projectId: string;
  visible: boolean;
  onClose: () => void;
}

function ScheduleEditDrawer({
  enterpriseId,
  projectId,
  visible,
  onClose,
}: ScheduleEditDrawerProps) {
  const dispatch = useDispatch();
  const schedule = useSelector(
    (state: RootState) => state.schedules.schedule.data,
  );

  const onCreate = async (data: any) => {
    if (!schedule) return;
    const children = schedule.children.map((child: any) => {
      return child.id;
    });
    const depends = schedule.depends.map((depend: any) => {
      return depend.id;
    });
    dispatch(
      updateScheduleAsync.request({
        enterpriseId,
        projectId,
        scheduleId: schedule.id + '',
        schedule: {
          ...data,
          children,
          depends,
          projectId: +projectId,
          startDate: moment(data.startDate).format('YYYY-MM-DD'),
          finishDate: moment(data.finishDate).format('YYYY-MM-DD'),
        },
      }),
    );

    /**
     * setTimeout: update schedule list
     */
    setTimeout(() => {
      dispatch(
        getScheduleListAsync.request({
          enterpriseId,
          projectId,
          type: ScheduleListType.TREE_LIST,
        }),
      );
    }, 1000);

    onClose();
  };

  return (
    <>
      <Drawer
        width={700}
        placement="right"
        closable={true}
        maskClosable={false}
        onClose={onClose}
        open={visible}
        title={<Title level={3}>공정 수정</Title>}
      >
        {visible && schedule && (
          <ScheduleCreateUpdateComponent
            schedule={schedule}
            onCreate={onCreate}
            onCancel={onClose}
          />
        )}
      </Drawer>
    </>
  );
}

export default ScheduleEditDrawer;
